var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_c('strong',[_vm._v("Generate Polls for LinkedIn")])]),_c('h5',[_vm._v("\n    Kindly input a broad topic or subject that you would like the poll to revolve around.\n    (Examples are: Technology Trends, Environmental Issues, Health and Wellness)\n  ")]),_c('p',[_vm._v("\n    Write your message in the box below.\n  ")])])
}]

export { render, staticRenderFns }